import React from 'react';
import {useSelector} from "react-redux";
import {productOptions, productsLoading} from "./productConfigSlice";
import {Spinner} from "@deere/ux.uxframe-react";
import {TextFilter, WtyReportTable} from "../common/wty-report-table/WtyReportTable";
import {languageResponseData} from "../Translation/translationSerachSlice";

const OptionList = () => {

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
    };;

    const prodOptions = useSelector(productOptions);
    const productOptionsLoading = useSelector(productsLoading);

    const productOptionColumns = [
        {
            Header: translate('code1', 'Code'),
            accessor: 'categoryName',
            Filter: TextFilter
        },
        {
            Header:  translate('component1', 'Component'),
            accessor: 'categoryDescription',
            Filter: TextFilter
        },
        {
            Header:translate('base_machine_code', 'Base Machine Code'),
            accessor: 'baseMachineCode',
            Filter: TextFilter
        }
    ];

    const baseMachineCode = prodOptions?.productDetails?.productCategories
        .find(category => category.categoryType === 'Base Machine Code')?.categoryName;

    const data = prodOptions?.productConfiguration?.options;

    let productOptionsMapped = [];

    if (data) {
        productOptionsMapped = Object.entries(data).map(([key, value]) => ({
            ...value,
            baseMachineCode,
        }))
    }

    return (
        <>
            {
                productOptionsLoading ? (
                    <div className="uxf-spinner-border-inline mt-4">
                        <Spinner className="uxf-spinner-border-sm" animation="border"
                                 accessibilityLabel="Loading Product components"/>
                        <p aria-hidden="true" className="uxf-spinner-border-inline-text">
                            Loading Product components...
                        </p>
                    </div>
                ) : (
                    prodOptions?.productConfiguration?.options &&
                    Object.entries(prodOptions?.productConfiguration?.options).length ? (
                        <WtyReportTable columns={productOptionColumns} data={productOptionsMapped}/>
                    ) : (
                        <span>{translate('message10','No Option Codes found for the Product.')}</span>
                    )
                )
            }
        </>
    )

}

export default OptionList;